import React from "react";
import "./TempleBackground.css";

export default function TempleBackground({ children }) {
  return (
    <div className="temple-background">

      {/* Glitter particles */}
      <div className="glitter glitter-1"></div>
      <div className="glitter glitter-2"></div>
      <div className="glitter glitter-3"></div>
      <div className="glitter glitter-4"></div>
      <div className="glitter glitter-5"></div>
      <div className="glitter glitter-6"></div>
      <div className="glitter glitter-7"></div>
      <div className="glitter glitter-8"></div>
      <div className="glitter glitter-9"></div>
      <div className="glitter glitter-10"></div>

      {/* Your complete website */}
      <div className="temple-content">
        {children}
      </div>

    </div>
  );
}